import styled from 'styled-components';

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
`

export const ListContainer = styled.div`
  max-height: 80vh;
  overflow-x: auto;
`;